export {}

const headerDropdownItems = document.querySelectorAll<HTMLElement>(".i-header-dropdown")

headerDropdownItems.forEach((item) => {
  const close = item.querySelector(".i-header-dropdown__close")
  const formActions = [
    {selector: ".--js-open-login", className: "--login"},
    {selector: ".--js-open-registration", className: "--registration"},
    {selector: ".--js-open-forgotten-password", className: "--forgotten-password"},
  ]

  const openForm = (className: string) => {
    item.classList.remove("--login", "--registration", "--forgotten-password")
    item.classList.add(className)
  }

  formActions.forEach(({selector, className}) => {
    const openFormLink = item.querySelectorAll(selector)
    openFormLink.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault()
        openForm(className)
      })
    })
  })

  close?.addEventListener("click", () => {
    item.classList.remove("--open")
  })
})

document.addEventListener("click", (e) => {
  const target = e.target
  if (target instanceof HTMLElement && !target.closest(".i-header-dropdown, .i-user"))
    headerDropdownItems.forEach((item) => item.classList.remove("--open"))
})
